module.exports = __webpack_public_path__ + "media/images/emblems/ZihlschlachtSitterdorf-blazon-9a9c2499d3e78a76514b9b12a4eec222.svg";